import {useVesselsQuery} from '../query/vessels'

export function useHasActiveVessels(options?: {suspense: boolean}): boolean {
    const {data: vessels} = useVesselsQuery({suspense: options?.suspense ?? false})
    const hasActiveVessel = vessels?.some((vessel) => vessel.status === 'ACTIVE')

    return Boolean(hasActiveVessel)
}
